/**
 * @ngdoc directives
 * @memberof mercury.directives
 * @name focusonshow
 * @description Focus on element when it is shown (only for those that are not shown by default)
 */
angular.module('mercury.directives.focusonshow', [])
.directive('focusOnShow', ["$timeout", function($timeout) {
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        scope.$watch(attrs.ngShow, function(newValue) {
          if (newValue) {
            $timeout(function() {
              element[0].focus();
            }, 0);
          }
        });
      }
    };
  }]);